module.exports = __webpack_public_path__ + "img/4.675ab58b.png";